import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetUserQuery } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { getUnexpectedErrorMessage } from 'packages/common-frontend/utils';
import { AssignmentLoadingSkeleton } from 'packages/loanProduct/ui/AssignmentSkeletonLoadingTables';
import { AssignmentSelectStrategyContainer } from 'packages/loanProduct/ui/assignmentStrategy/AssignmentSelectStrategyContainer';
import 'borrower/borrower.scss';

export const AssignmentSelectStrategyRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  const { data: userData, loading: userLoading } = useGetUserQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = getUnexpectedErrorMessage(err);
      toast(errorToastConfig);
    },
  });

  if (!userData || !userData.user || userLoading) {
    return (
      <AssignmentLoadingSkeleton dataTestId="loading-assignment-edit-route" />
    );
  }

  return (
    <Box margin="0 auto" width="100%" maxWidth="1600px">
      <Box className="main">
        <Sentry.ErrorBoundary
          onError={() => {
            if (!routeLevelError && !toast.isActive(errorToastId)) {
              errorToastConfig.title = `Failed to load assignment select strategy route`;
              routeLevelError = true;
              toast(errorToastConfig);
              navigate('/');
            }
          }}
        >
          <AssignmentSelectStrategyContainer />
        </Sentry.ErrorBoundary>
      </Box>
    </Box>
  );
};
